module.exports = __webpack_public_path__ + "assets/img/season2-f6a16f10.png";